import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {FormGroup} from '@angular/forms';
import {environment} from '../../../environments/environment';

export interface RepositoryInterface {

  getAll(): Observable<any[]>;

  getById(id: number): Observable<any>;

  post(entity: any): Observable<any>;

  put(entity: any, id: number): Observable<any>;

  delete(id: number): Observable<any>;

}

export abstract class AbstractService implements RepositoryInterface {

  private readonly apiUrl: string;

  protected constructor(apiUrl: string, public http: HttpClient) {
    this.apiUrl = apiUrl;
  }

  public getAll(relativeUrl?: string): Observable<any[]> {
    return this.http.get<any[]>(this.getUrl(relativeUrl), this.headers())
      .pipe(map(this.extractListData), catchError(this.handleError));
  }

  public filterByParam(params?: any, relativeUrl?: string): Observable<any[]> {
    return this.http.get<any[]>(this.getUrl(relativeUrl), {params}).pipe(map(this.extractData));
  }

  public getById(id?: number, relativeUrl?: string): Observable<any> {
    const strId = id ? `${id}` : '';
    let url = `${strId}`;
    if (relativeUrl) {
      url = `${relativeUrl}/${strId}`;
    }
    // @ts-ignore
    return this.http.get<any>(this.getUrl(url), this.headers())
      .pipe(map(this.extractData));
  }

  public getOne(relativeUrl: string): Observable<any> {
    // @ts-ignore
    return this.http.get<any>(this.getUrl(relativeUrl), this.headers())
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  public getBy(param?: any, relativeUrl?: string): Observable<any> {
    // const strParam = param ? `${param}` : '';
    // let url = `${strParam}`;
    // if (relativeUrl) {
    //   url = `${relativeUrl}`;
    // }
    // @ts-ignore
    return this.http.get<any>(this.getUrl(relativeUrl), {headers: this.headers(), params: param})
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  public post(entity: any, relativeUrl?: string): Observable<any> {
    // @ts-ignore
    return this.http.post<T>(this.getUrl(relativeUrl), entity, this.headers())
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  public postFormData(entity: FormData, relativeUrl?: string): Observable<any> {
    // @ts-ignore
    return this.http.post<T>(this.getUrl(relativeUrl), entity)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  public postFormGroup(entity: FormGroup, relativeUrl?: string): Observable<any> {
    // @ts-ignore
    return this.http.post<any>(this.getUrl(relativeUrl), entity)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  public put(entity: any, id: number, relativeUrl?: string): Observable<any> {
    const strId = id ? `${id}` : '';
    let url = `${strId}`;
    if (relativeUrl) {
      url = `${relativeUrl}/${strId}`;
    }
    // @ts-ignore
    return this.http.put<any>(this.getUrl(url), entity, this.headers())
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  public delete(id: number): Observable<any> {
    return this.http.delete(this.getUrl(`${id}`), this.headers()).pipe(catchError(this.handleError));
  }

  public deleteAll(param: any): Observable<any> {
    return this.http.delete(this.getUrl(), {params: param}).pipe(catchError(this.handleError));
  }

  protected getUrl(relativeUrl?: string): string {
    let absoluteUrl = `${environment.apiUrl}/${this.apiUrl}`;
    if (relativeUrl !== null && relativeUrl !== undefined) {
      absoluteUrl += `/${relativeUrl}`;
    }
    return absoluteUrl;
  }

  protected handleError(error: HttpErrorResponse) {

    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.log(error);
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(error.error);
  }

  protected headers() {

    return {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };
  }

  protected extractListData(res: any): Array<any> {

    if (res && res.resposta && res.resposta.length) {
      return res.resposta;
    }
    return res;
  }

  protected extractData(res: any): any {
    if (res) {
      return res;
    }
    return {};
  }

}
